<template>
  <div id="app">
    <component :is="this.$route.meta.layout || 'div'">
      <router-view />
    </component>
  </div>
</template>

<script>
//import { setAuthHeader } from '@/backend/axios'

export default {
  name: 'App',
  // created(){
  //   var token = this.$cookies.get('auth_token')
  //   if(token !== undefined && token !== null)
  //   {
  //     setAuthHeader(token)    
  //   }    
  //   else{
  //     setAuthHeader({})
  //   }
  // }
}
</script>


<style lang="scss">

p.dev-info {
  font-style: italic;
}
.font-weight-light {
  font-family: 'Tidningsretur Normal'
}

</style>